/**
 * The dashboard's Recharts theme — one set of props for every chart, so a
 * chart on any page looks the same and follows dark mode.
 *
 * Recharts paints its own defaults — a #ccc grid and hover cursor, #666 axis
 * lines and tick labels (the tick fill follows the axis stroke), a white
 * tooltip with a #ccc border, a white ring on the hover dot. They are passed
 * explicitly as theme tokens whose LIGHT value is that same default, so light
 * renders exactly as before and dark mode can re-tone them (styles.css
 * section 0). The tooltip wears the overlay surface, which lifts in dark.
 *
 * Lifted out of `pages/Analytics.tsx` (email-campaigns, 2026-10-17) when
 * `/campaigns` became the second page with a chart.
 */

export const CHART_HEIGHT = 220;
export const AXIS_STYLE = { fontSize: 11 } as const;
export const GRID_STROKE = "var(--c-chart-grid)";
export const AXIS_STROKE = "var(--c-chart-axis)";
export const TOOLTIP_CONTENT_STYLE = {
  backgroundColor: "var(--c-surface-pop)",
  border: "1px solid var(--c-line-82)",
} as const;
// The hover dot on a line keeps the series colour as its fill; its ring is
// Recharts' default white, passed as a token so dark rings it in the panel
// colour instead of drawing a white blob.
export const ACTIVE_DOT = { stroke: "var(--c-chart-dot-ring)" } as const;
// A line chart's cursor is a stroked line; a bar chart's is a filled band
// that Recharts draws with stroke "none". Only the fill is overridden there:
// adding a stroke would widen the band by half a pixel on each side in light.
export const LINE_CURSOR = { stroke: "var(--c-chart-cursor)" } as const;
export const BAR_CURSOR = { fill: "var(--c-chart-cursor)" } as const;
